import React from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
const Download = dynamic(() => import("../detail-post/post-form"),{ssr: true});
const Button = dynamic(() => import("@/Components/Button"));

interface ButtonLink {
  href: string;
  label: string;
}

interface Button {
  link?: ButtonLink;
}

interface Block {
  type: "type-1" | "type-2" | "type-3" | string;
  theme: "primary" | "secondary" | "muted" | "download" | string;
  title: string;
  text?: string;
  buttons?: Button[];
}

interface BlogCtaProps {
  block: Block;
  handleShowConnect?: () => void;
  handleShowRate?: () => void;
  handleShowBusiness?: () => void;
}

const BlogCta: React.FC<BlogCtaProps> = ({ block }) => {
  const router = useRouter(); // handleShowConnect,handleShowRate,handleShowBusiness,
  const HandleClick = () => {
    const request = "request-proposal";
    const path = block.buttons?.[0]?.link?.href;
    const url = path?.includes(request)
      ? "/" + request
      : !path
        ? request
        : path;
    router.push(url ?? "/");
  };

  const MutedCtaSection: React.FC = () => (
    <section
      id="muted-cta"
      className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[90px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10"
    >
      <div className="container">
        <div className="heading mb-[40px] lg:mb-[40px] xl:mb-[56px]">
          <h2 className="lg:text-[48px] xl:text-[40px] xm:text-[32px] xm:text-[32px] text-[26px] text-center xl:leading-[52px] lg:leading-[62.4px] xm:leading-[41.6px] leading-[35px] font-[700] text-[#040405]">
            {block.title ?? ""}
          </h2>
          <p className="text-subtitle-2 text-center font-regular mt-3">
            {block?.text ?? ""}
          </p>
        </div>
        {block.buttons?.[0]?.link?.label && (
          <div className="flex items-center justify-center">
            <Button
              variant="small"
              className="my-0"
              onClick={HandleClick}
              label={block.buttons?.[0]?.link?.label ?? "Schedule a Call"}
            />
          </div>
        )}
      </div>
    </section>
  );

  switch (block.theme) {
    case "muted":
    case "primary":
    case "secondary":
      return <MutedCtaSection />; // return <SecondaryCtaSection />;// return <PrimaryCtaSection />;
    case "download":
      return <Download data={block} />;
    default:
      return <></>;
  }
};

export default BlogCta;
